export const Props = () => ({
  //--------------------------------------------------------------------------
  //                            Размер заглушки
  //--------------------------------------------------------------------------
  size: {
    type: Number,
    default: 24,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});